import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/src/layouts/auth.vue").then(m => m.default || m)),
  blank: defineAsyncComponent(() => import("/src/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/src/layouts/default.vue").then(m => m.default || m))
}